import React, { Component } from 'react';
import { Typography, message, Alert, Row, Col, Divider, Tag, Checkbox } from 'antd';
import { CarOutlined, CheckCircleOutlined, NumberOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import axios from "axios";
import { ModalItem, ButtonItem} from "../../../../Components/Items";

const { Text } = Typography;

class ModalConfirmarTransito extends Component {
  state = {
    cargando: false,
    enviarCorreo: this.props.enviarCorreoDefault !== false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ enviarCorreo: this.props.enviarCorreoDefault !== false });
    }
  }

  confirmarTransito = () => {
    const { venta, origenKey, empresaId, headersToken, onSuccess } = this.props;
    const { enviarCorreo } = this.state;

    this.setState({ cargando: true });

    axios.post("ventasEcommerce/actualizarEstadoPaquete", {
      empresaId,
      ventaId: venta._id,
      origenKey,
      nuevoEstado: 4, // Estado 4 = En tránsito
      enviarCorreo,
    }, { headers: headersToken })
    .then(res => {
      this.setState({ cargando: false });
      if (res.data.success === 1) {
        message.success("¡Paquete marcado en tránsito!");
        onSuccess();
      } else {
        message.warning(res.data.message);
      }
    })
    .catch(() => {
      this.setState({ cargando: false });
      message.error("Error al conectar con el servidor.");
    });
  };

  render() {
    const { visible, onCancel, venta, envio } = this.props;
    const { cargando, enviarCorreo } = this.state;

    if (!venta || !envio) return null;

    const nombreCliente = `${venta.clienteOnline?.nombre || ""} ${venta.clienteOnline?.apellidoPaterno || ""}`.trim();

    return (
      <ModalItem
        title={<span><CarOutlined /> Confirmar Salida a Tránsito</span>}
        visible={visible}
        onCancel={onCancel}
        width={500}
        spinning={cargando}
      >
        <Alert 
          message="¿El paquete ya fue recolectado?"
          description="Al confirmar, este paquete pasará a estar 'En tránsito' y el cliente podrá empezar a rastrearlo."
          type="info" 
          showIcon 
          style={{ marginBottom: 15, marginTop : 15 }}
        />

        <div style={{ background: '#f5f5f5', padding: '15px', borderRadius: '8px', marginBottom: '15px' }}>
            <Row gutter={[0, 10]}>
                <Col span={24}>
                    <Text type="secondary" style={{ fontSize: '12px' }}>Folio de Venta:</Text><br/>
                    <Text strong>{venta.serieNumero}</Text>
                </Col>
                <Col span={24}>
                    <Text type="secondary" style={{ fontSize: '12px' }}>Cliente:</Text><br/>
                    <Text strong>{nombreCliente}</Text>
                </Col>
                <Divider style={{ margin: '8px 0' }} />
                <Col span={12}>
                    <Text type="secondary" style={{ fontSize: '12px' }}>Paquetería:</Text><br/>
                    <Tag color="geekblue">{envio.carrier?.toUpperCase()}</Tag>
                </Col>
                <Col span={12}>
                    <Text type="secondary" style={{ fontSize: '12px' }}>Tracking:</Text><br/>
                    <Text strong><NumberOutlined /> {envio.trackingNumber || "Sin rastreo"}</Text>
                </Col>
                {envio.folioRecoleccion && (
                    <Col span={24} style={{ marginTop: '10px' }}>
                        <Text type="secondary" style={{ fontSize: '12px' }}>Folio Recolección Envia:</Text><br/>
                        <Text strong style={{ color: '#fa8c16' }}>{envio.folioRecoleccion}</Text>
                    </Col>
                )}
            </Row>
        </div>

        <Checkbox
          checked={enviarCorreo}
          onChange={(e) => this.setState({ enviarCorreo: e.target.checked })}
          style={{ marginBottom: 15 }}
        >
          Enviar correo al cliente con la actualización del estado
        </Checkbox>

        <div style={{ textAlign: "right", marginBottom: 15 }}>
          <ButtonItem onClick={onCancel} blanco style={{ marginRight: 8 }}>Cancelar</ButtonItem>
          <ButtonItem 
             type="primary" 
             style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', color: 'white' }}
             icon={<CheckCircleOutlined />}
             onClick={this.confirmarTransito}
          >
            Sí, ya está en tránsito
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalConfirmarTransito);